// extracted by mini-css-extract-plugin
module.exports = {"captureButton":"FileUploader_captureButton__2zVI-","modal":"FileUploader_modal__2FfSc"};